import { FormatAnnotationPlusIcon } from './FormatAnnotationPlusIcon';

/**
 * author: Kai Faust
 * id 591A45AB-511C-4791-957C-303186C666AA
 * name format-annotation-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-annotation-plus.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatAnnotationAddIcon = FormatAnnotationPlusIcon;
export default FormatAnnotationAddIcon